import { render } from "./TicketStep2.vue?vue&type=template&id=a6f4ca4a"
import script from "./TicketStep2.vue?vue&type=script&lang=js"
export * from "./TicketStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__